import axios from "axios";
import { appConst } from "../../AppConst";
import { ICommonRequest } from "../../model/request/ICommonRequest";
import { IDonHangChiTiet } from "../../model/respone/don-hang/IDonHangChiTiet";
import { apiClient } from "../apiClient";

export interface IDonHangChiTietExportRequest extends ICommonRequest {
    uf_trangthaidonhang_ids?: number[];
    tu_ngay?: string | null;
    den_ngay?: string | null;
}

export const DON_HANG_CHI_TIET_API_RESOURCE = "don-hang-chi-tiet"
export const donHangChiTietApi = {
    SelectAll: (payload:ICommonRequest) => apiClient.post(`${DON_HANG_CHI_TIET_API_RESOURCE}/select-all`,payload),
    GetByDonHang: (id: number) => apiClient.get(`${DON_HANG_CHI_TIET_API_RESOURCE}/don-hang/${id}`),
    ExportExcel: async (request: IDonHangChiTietExportRequest) => {
        const url = `${appConst.baseApiURL}/${DON_HANG_CHI_TIET_API_RESOURCE}/export-excel`;
        const response = await axios.post(url, request, {
            responseType: "blob",
            headers: {
                Authorization: `Bearer ${localStorage.access_token}`,
                language: localStorage.getItem("language") || "",
            },
        });

        const contentDisposition = response.headers["content-disposition"] as string | undefined;
        const fileNameMatch = contentDisposition?.match(/filename="?([^";]+)"?/i);

        return {
            blob: response.data as Blob,
            fileName: fileNameMatch?.[1] || "danh-sach-san-pham-trong-don-hang.xlsx",
        };
    },
    Insert: (payload: IDonHangChiTiet) => apiClient.post(`${DON_HANG_CHI_TIET_API_RESOURCE}`, payload),
    Update: (payload: IDonHangChiTiet) => apiClient.put(`${DON_HANG_CHI_TIET_API_RESOURCE}`, payload),
    Delete: (id: number) => apiClient.delete(`${DON_HANG_CHI_TIET_API_RESOURCE}/${id}`),
}